import React from 'react';
import Toggle from 'common/components/Toggle';
import useMapsStore from '../store/useMapsStore';
import settings from '../util/config';
import Dropdown from './Dropdown';
import MobileFilterBar from './MobileFilterBar';
import DesktopFilterBar from './DesktopFilterBar';
import { getUTCHtmlId } from 'common/util/time';
import useLotsStore from '../store/useLotsStore';
const Filters = ({ isMobile = false, filtersRef }) => {
    const { filteredLots } = useLotsStore(["filteredLots"]);
    const { lotListExpanded, setLotListExpanded } = useMapsStore();
    const filterSectionHeadingId = 'desktop-filter-label-' + getUTCHtmlId();
    return (React.createElement("div", { ref: filtersRef, className: "viewport-map__filters" }, isMobile ? (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { toggleClass: "viewport-map__filters__mobile-dropdown-toggle", toggleChildren: React.createElement(React.Fragment, null,
                React.createElement("img", { role: "presentation", src: "/Assets/icons/icon-filters.svg" }),
                React.createElement("span", { className: "sr-only" }, "Toggle Filter Dropdown")), contentClass: "viewport-map__filters__mobile-dropdown-content", fullHeight: true },
            React.createElement(MobileFilterBar, null)),
        React.createElement("p", { className: "viewport-map__filters__lot-count", "aria-live": "assertive" },
            React.createElement("b", { className: "strong" }, filteredLots.length),
            settings.HomesAvailableLabelMobile?.replace('[homes]', '')),
        React.createElement(Toggle, { toggleTextTrue: settings.ShowListLabel, toggleTextFalse: settings.ShowMapLabel, checked: !lotListExpanded, onChange: (isCheckedNow) => setLotListExpanded(!isCheckedNow) }))) : (React.createElement("section", { className: "viewport-map__filters__desktop-filters", "aria-labelledby": filterSectionHeadingId },
        React.createElement("h2", { id: filterSectionHeadingId, className: "sr-only" }, settings.FilterSectionLabel),
        React.createElement(Toggle, { toggleTextTrue: settings.HideListLabel, toggleTextFalse: settings.ShowListLabel, checked: lotListExpanded, onChange: (isCheckedNow) => setLotListExpanded(isCheckedNow) }),
        React.createElement("span", { className: "vertical-divider" }),
        React.createElement(DesktopFilterBar, null)))));
};
export default Filters;
export const MemoizedFilters = React.memo(Filters);
